import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { Size } from '../../../../Enums/Size.enum';
import PatientsGroupsAddMembersByImport from './PatientsGroupsAddMembersByImport';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
	groupId: string;
}

const PatientsGroupsAddMembersByImportModal: React.FC<Props> = ({
	isOpen,
	onClose,
	onSuccess,
	groupId,
}) => {
	return (
		<Modal opened={isOpen} onClose={onClose} size={Size.LG}>
			<Modal.Header title='component.groupMsgs.addUsersFromFile' />
			<Modal.Content>
				<PatientsGroupsAddMembersByImport
					onSuccess={onSuccess}
					groupId={groupId}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default PatientsGroupsAddMembersByImportModal;
